import {
  FETCH_DOC_REQUEST,
  FETCH_DOC_SUCCESS,
  FETCH_DOC_FAILURE,
  SEARCH_DOCS,
  SEARCH_DOCS_RESULTS,
  SEARCH_DOCS_CLEAR,
} from "./types";

export const fetchDocRequest = (docPath) => ({
  type: FETCH_DOC_REQUEST,
  payload: docPath,
});

export const fetchDocSuccess = (docPath, content) => ({
  type: FETCH_DOC_SUCCESS,
  payload: { docPath, content },
});

export const fetchDocFailure = (docPath, error) => ({
  type: FETCH_DOC_FAILURE,
  payload: { docPath, error },
});

export const searchDocs = (query) => ({
  type: SEARCH_DOCS,
  payload: query,
});

export const searchDocsResults = (results) => ({
  type: SEARCH_DOCS_RESULTS,
  payload: results,
});

export const searchDocsClear = () => ({
  type: SEARCH_DOCS_CLEAR,
});
